import { BridgeContainer } from '@/features/bridge/BridgeContainer'

export function BridgePage() {
  return <BridgeContainer withHeading />
}
